import classNames from 'classnames'
import { HTMLAttributes } from 'react'

import styles from './price-discount-strike.module.scss'

export type PriceDiscountStrikeElement = HTMLSpanElement

export type PriceDiscountStrikeProps = HTMLAttributes<PriceDiscountStrikeElement>

function PriceDiscountStrike(props: PriceDiscountStrikeProps) {
  const { children, className, ...rest } = props
  const classes = classNames(styles.root, className)
  return (
    <strong className={classes} {...rest}>
      {children}
    </strong>
  )
}

export default PriceDiscountStrike
